import React from 'react';
import { Align, FontSize } from '../../modules/ReceiptLayouts/Model';
export var Texto = function (_a) {
    var texto = _a.texto, align = _a.align, fontSize = _a.fontSize, bold = _a.bold;
    return (React.createElement("p", { style: { lineHeight: '1.2', width: '100%', textAlign: align ? align : defaultProps.align, margin: '0', fontSize: fontSize ? fontSize : defaultProps.fontSize, fontWeight: bold ? 'bold' : 'normal' } }, texto));
};
var defaultProps = {
    align: Align.Center,
    fontSize: FontSize.normal,
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Texto.tsx
// module id = 51
// module chunks = 0